// src/components/editor/ToolsPanel.jsx
import React from 'react';
import { Box, Button, Typography, Switch, FormControlLabel } from '@mui/material';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import NotesIcon from '@mui/icons-material/Notes';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

const toolBtnSx = {
  backgroundColor: '#5a4d99',
  color: '#F5D76E',
  justifyContent: 'flex-start',
  textTransform: 'none',
  py: 1.5,
  '&:hover': { backgroundColor: '#6a5da9' },
};

const ToolsPanel = ({
  onSpellCheck,
  onWordCount,
  onCitations,
  showLineNumbers,
  onToggleLineNumbers,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, color: 'white' }}>
      <Typography variant="subtitle2" sx={{ color: '#F5D76E', fontWeight: 600, mb: 1 }}>
        WRITING TOOLS
      </Typography>

      <Button variant="contained" startIcon={<SpellcheckIcon />} onClick={onSpellCheck} sx={toolBtnSx}>
        Spelling
      </Button>

      <Button variant="contained" startIcon={<MenuBookIcon />} onClick={onCitations} sx={toolBtnSx}>
        Citations
      </Button>

      <Button variant="contained" startIcon={<NotesIcon />} onClick={onWordCount} sx={toolBtnSx}>
        Word Count
      </Button>

      <FormControlLabel
        control={
          <Switch
            checked={!!showLineNumbers}
            onChange={(e) => onToggleLineNumbers?.(e.target.checked)}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': { color: '#F5D76E' },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#F5D76E' },
            }}
          />
        }
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'white' }}>
            <FormatListNumberedIcon sx={{ color: '#F5D76E', fontSize: 20 }} />
            <span>Line Numbers</span>
          </Box>
        }
        sx={{ ml: 0.5, mt: 0.5 }}
      />
    </Box>
  );
};

export default ToolsPanel;
